// src/api/auth.js
import API from "./axiosConfig";
import { exchangeExternalToken } from "./parkpassAuth";

export const loginUser = async (email, password) => {
  try {
    const response = await API.post("/agents/login", { email, password });
    const loginData = response.data;
    
    // Check if user has external_user_id and parkpass_token
    if (loginData.info?.external_user_id && loginData.parkpass_token) {
      try {
        // Exchange parkpass_token for real access token
        const parkpassData = await exchangeExternalToken(loginData.parkpass_token);
        
        // Add ParkPass tokens to the response data
        return {
          ...loginData,
          parkpass_token: parkpassData.access_token,
          parkpass_refresh_token: parkpassData.refresh_token,
        };
      } catch (parkpassError) {
        console.error("Failed to exchange ParkPass token:", parkpassError);
        // Continue with normal login even if ParkPass fails
        return loginData;
      }
    }
    
    return loginData;
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const logoutUser = async () => {
  try {
    const response = await API.get("/agents/logout");
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};
